// The Penyedia work tools of a paket project, ready to mount in the stage
// view: each one takes the project id and loads and saves its own data
// (/paketwork/:id/...). workSectionsByStage lists the tools of each stage
// in display order; a stage without tools maps to an empty list.
import type { ComponentType } from "react";
import { KalkulatorRab } from "./KalkulatorRab";
import { PengendalianKontrak } from "./PengendalianKontrak";
import { QualityGate } from "./QualityGate";
import { ReviuPersyaratan } from "./ReviuPersyaratan";

export { KalkulatorRab, PengendalianKontrak, QualityGate, ReviuPersyaratan };

/** The four Penyedia stages (selesai and ditutup are end statuses, not stages). */
export type WorkStage = "persiapan_pemilihan" | "pelaksanaan_pemilihan" | "pelaksanaan_kontrak" | "serah_terima";

export interface WorkSectionProps {
  projectId: string;
}

export interface WorkSectionEntry {
  /** Stable key, also the section's data-tool attribute. */
  id: "reviu-persyaratan" | "kalkulator-rab" | "quality-gate" | "pengendalian-kontrak";
  label: string;
  Component: ComponentType<WorkSectionProps>;
}

export const WORK_SECTIONS = {
  reviuPersyaratan: { id: "reviu-persyaratan", label: "Reviu Persyaratan", Component: ReviuPersyaratan },
  kalkulatorRab: { id: "kalkulator-rab", label: "Kalkulator RAB", Component: KalkulatorRab },
  qualityGate: { id: "quality-gate", label: "Quality Gate", Component: QualityGate },
  pengendalianKontrak: { id: "pengendalian-kontrak", label: "Pengendalian Kontrak", Component: PengendalianKontrak },
} as const satisfies Record<string, WorkSectionEntry>;

export const workSectionsByStage: Record<WorkStage, readonly WorkSectionEntry[]> = {
  persiapan_pemilihan: [],
  pelaksanaan_pemilihan: [WORK_SECTIONS.reviuPersyaratan, WORK_SECTIONS.kalkulatorRab, WORK_SECTIONS.qualityGate],
  pelaksanaan_kontrak: [WORK_SECTIONS.pengendalianKontrak],
  serah_terima: [],
};

/** The tools of `stage`; none for an unknown stage or an end status. */
export function workSectionsFor(stage: string | null | undefined): readonly WorkSectionEntry[] {
  return stage && stage in workSectionsByStage ? workSectionsByStage[stage as WorkStage] : [];
}
